/* eslint-disable import/no-cycle */
import dayjs from 'dayjs';

export { default as BirthDate } from './BirthDate';
export { default as CreditCardInput } from './CreditCardInput';
export { default as SelectField } from './SelectField';
export { default as SubmitButton } from './SubmitButton';
export { default as FormErrors } from './FormErrors';
export { default as FieldError } from './FieldError';
export { default as TextArea } from './TextArea';
export { default as InputField } from './InputField';
export { default as DatePicker } from './DatePicker';
export { default as AgeVerification } from './AgeVerification';
export { default as Form } from './Form';
export { default as CustomFormErrors } from './CustomFormErrors';
// export { default as FormColumns } from './FormColumns';
// export { default as SubmitButton } from './SubmitButton';
// export { default as FormActions } from './FormActions';
// export { default as FormApiError } from './FormApiError';
// export { default as FormSuccess } from './FormSuccess';

export { default as RadioGroup } from './RadioGroup';
export { default as Radio } from './Radio';

export { default as CheckBoxGroup } from './CheckBoxGroup';
export { default as CheckBox } from './CheckBox';

export const normalizeInteger = (value) => {
  if (!value) {
    return value;
  }
  const number = value.replace(/[^0-9]/g, '');
  return number;
};

export const normalizeDecimal = (value) => {
  if (!value) {
    return value;
  }
  const number = value.replace(/[^0-9.]/g, '');
  return number;
};

export const normalizeDate = (date) => {
  if (date) {
    try {
      return dayjs(date).format('MMM D, YYYY');
    } catch {
      return date;
    }
  }
  return '';
};

export const normalizeCreditCard = (creditCardNumber) => {
  const cardNumber = removeNonIntegers(creditCardNumber);
  const standardSlices = [4, 4, 4, 4];
  const amexSlices = [4, 6, 5];

  if (cardNumber === undefined || !cardNumber.length) {
    return cardNumber;
  }

  const creditCardBrand = getCreditCardBrand(creditCardNumber);

  switch (creditCardBrand) {
    case 'Visa':
    case 'Discover':
    case 'JCB':
    case 'MasterCard':
      return slicedCardNumber(standardSlices, cardNumber);
    case 'American Express':
      return slicedCardNumber(amexSlices, cardNumber);
    default:
      return cardNumber;
  }
};

export const getCreditCardBrand = (creditCardNumber) => {
  const cardNumber = removeNonIntegers(creditCardNumber);

  const visa = /^4/;
  const amex = /^3(4|7)/;
  const dinersClubCB = /^30[0-5]/;
  const dinersClubInt = /^36/;
  const discover = /^6(011|4[4-9]|5|22[1-9]{3})/;
  const masterCard = /^5[1-5]/;
  const jcb = /^35[0-9]{2}/;

  switch (true) {
    case visa.test(cardNumber):
      return 'Visa';
    case amex.test(cardNumber):
      return 'American Express';
    case dinersClubCB.test(cardNumber):
      return 'Diners Club';
    case dinersClubInt.test(cardNumber):
      return 'Diners Club';
    case discover.test(cardNumber):
      return 'Discover';
    case masterCard.test(cardNumber):
      return 'MasterCard';
    case jcb.test(cardNumber):
      return 'JCB';
    default:
      return '';
  }
};

const slicedCardNumber = (slices, creditCard) => {
  let start = 0;
  let formattedCardNumber = '';
  const cardNumber = removeNonIntegers(creditCard);
  slices.forEach((slicePoint) => {
    formattedCardNumber += `${cardNumber.slice(start, (start += slicePoint))} `;
  });
  // for (const slicePoint of slices) {
  //   formattedCardNumber += `${cardNumber.slice(start, (start += slicePoint))} `;
  // }
  return formattedCardNumber.trim();
};

const removeNonIntegers = (creditCardNumber) =>
  creditCardNumber !== undefined && creditCardNumber.replace(/[^\d]/g, '');

export const trimFormValues = (formValues) => {
  const trimedValues = { ...formValues };
  return trimObject(trimedValues);
};

const trimObject = (object) => {
  const trimedObject = { ...object };
  const keys = Object.keys(trimedObject);

  keys.forEach((key) => {
    const value = trimedObject[key];
    if (typeof value === 'string') {
      trimedObject[key] = trimString(value);
    } else if (Array.isArray(value)) {
      trimedObject[key] = trimArray(value);
    } else if (typeof value === 'object') {
      trimedObject[key] = trimObject(value);
    } else {
      trimedObject[key] = value;
    }
  });

  return trimedObject;
};

const trimString = (string = '') => string.trim();

const trimArray = (array) => {
  const trimedArray = [];

  array.forEach((arrayItem) => {
    if (typeof arrayItem === 'string') {
      trimedArray.push(trimString(arrayItem));
    } else if (typeof arrayItem === 'object') {
      trimedArray.push(trimObject(arrayItem));
    } else {
      trimedArray.push(arrayItem);
    }
  });

  return trimedArray;
};
